import Search from "../Search/Search";
import { StatusDropdown } from "../StatusDropdown/StatusDropdown";
import { CoursesDropdown } from "../CoursesDropdown/CoursesDropdown";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import { ReactComponent as HalfCircleICon } from "../../../assets/icons/filter/half-circle-svgrepo-com.svg";
import ExcelExportBtn from "../../ExcelExportBtn/ExcelExportBtn";
import { DatePick } from "../FilterComponents/DatePicker/DatePicker";
import { useLocation } from "react-router-dom";

const TeacherPageHead = ({
  openModal,
  search,
  filter,
  searchData,
  dataSearchValues,
  DATA_SEARCH_VALUE,
  count,
  statusType,
}) => {
  const location = useLocation();
  return (
    <div className="teacher-header-filter-container">
      {statusType !== "teachers-payment" && (
        <div className="teacher-page-add-btn">
          <button className="add-detail" onClick={openModal}>
            <PlusIcon />
            Əlavə et
          </button>
        </div>
      )}
      <div className="teacher-header-filter">
        {search &&
          location.pathname !== "/teachers-payments" &&
          location.pathname !== "/teachers-payments/mentors-payments" && (
            <Search
              searchData={searchData}
              dataSearchValues={dataSearchValues}
              className="search-input-con desktop"
              DATA_SEARCH_VALUE={DATA_SEARCH_VALUE}
            />
          )}
        {statusType !== "teachers-payment" &&
          location.pathname !== "/teachers-payments" &&
          location.pathname !== "/teachers-payments/mentors-payments" && (
            <StatusDropdown statusType="teacher" deviceType="desktop" />
          )}
        {location.pathname !== "/teachers-payments" &&
          location.pathname !== "/teachers-payments/mentors-payments" && (
            <CoursesDropdown deviceType="desktop" />
          )}
        {(location.pathname === "/teachers-payments" ||
          location.pathname === "/teachers-payments/mentors-payments") && (
          <DatePick deviceType="desktop" />
        )}
        {/* <GroupsDropdown deviceType="desktop" /> */}

        <div className="lesson-table-btn-container teacher ">
          <button className="add-detail" onClick={() => filter()}>
            Tətbiq et
          </button>
        </div>
        {location.pathname !== "/teachers-payments" &&
          location.pathname !== "/teachers-payments/mentors-payments" && (
            <>
              <div className="circle-icon">
                <p className="filter-count">{count || 0}</p>
                <HalfCircleICon />
              </div>
              <ExcelExportBtn pageName="teacher" />
            </>
          )}
      </div>
    </div>
  );
};

export default TeacherPageHead;
